import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';

// Selectors
import { selectIsOnline } from 'services/connection/selectors';

const ConnectionSnackbar: React.FC = () => {
    const isOnline = useSelector(selectIsOnline);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [key, setKey] = useState<string | number | null>(null);

    useEffect(() => {
        if (!isOnline && key === null) {
            // User goes offline, enqueue snackbar and store its key
            const newKey = enqueueSnackbar('Offline', {
                variant: 'default',
                persist: true,
            });
            setKey(newKey);
        } else if (isOnline && key !== null) {
            // User comes back online, close the snackbar
            closeSnackbar(key);
            setKey(null);
        }

        return () => {
            if (key !== null) {
                closeSnackbar(key);
            }
        };
    }, [isOnline, key, closeSnackbar, enqueueSnackbar]);

    return null;
};

export default ConnectionSnackbar;
